import React from 'react'
import Search from './Search'
import TicketList from './TicketList'

const Zendesk = () => {
  return (
    <div>
        <Search />
        <TicketList />
    </div>
  )
}

export default Zendesk